import React from 'react';
import { PiChatCircleDotsFill } from 'react-icons/pi';
import { useTheme, useUser } from 'react-ui';
import { useAssistantModal } from '../contexts/AssistantModal';
import { useBalloonEventsData } from '../contexts/EventData';

/**
 * The floating launcher button for the Beat Engineer assistant. Gated on the
 * `use-assistant` permission and hidden while the panel is open. Positioning is supplied
 * by the parent via `className`:
 * - desktop: docked bottom-right, clear of the mapbox geolocate control;
 * - mobile: rendered as a child of the BottomSheet and floated above its header (the same
 *   pattern the banners use), so it tracks the sheet instead of overlapping the events.
 */
export const AssistantLauncher: React.FC<{ className?: string }> = ({ className = '' }) => {
  const { user } = useUser();
  const { open, isOpen } = useAssistantModal();
  const { openedEvent } = useBalloonEventsData();
  const { primaryColor } = useTheme();

  if (!user?.hasPermission('use-assistant') || isOpen) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={() => open(openedEvent?.id ?? null)}
      aria-label="Open Beat Engineer assistant"
      title="Ask the Beat Engineer"
      style={{ backgroundColor: primaryColor }}
      className={
        'flex h-12 w-12 items-center justify-center rounded-full text-white shadow-lg transition hover:opacity-90 ' +
        className
      }
    >
      <PiChatCircleDotsFill className="h-6 w-6" />
    </button>
  );
};
